import { QuestionBase, QuestionControlOptions } from '../question-types/question-base';
import { isNil } from 'lodash';

export class RadioQuestion extends QuestionBase<string> {
  controlType = 'radio';
  options: [];
  displayInline: boolean;
  isValid = true;
 
  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
    this.displayInline = options['displayInline'] || false;
  }
}
